import { registerMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
const submitTrackRecommendationModelV2Click = ({
  correlationId
}) => http.put(`personalization/v1/recommendation/ml/hub-tier/cta-click/${correlationId}`);
export const SUBMIT_CTA_RECOMMENDATION_MODEL_V2_CLICK = registerMutation({
  fieldName: 'CTATrackRecommendationModelV2Click',
  args: ['correlationId'],
  fetcher: submitTrackRecommendationModelV2Click
});